class formValidation {
  constructor(elem) {
    this.form = elem;
    this.formMessage = JSON.parse(this.form.dataset.message);
    this.inputElements = this.form.querySelectorAll('input:not(.preventErrorEventListener)', ':not([type="radio"])');
    this.submit = this.form.querySelector('#book-submit');
    this.requiredMessage = `${this.formMessage.error.required}`;
    this.lettersOnlyMessage = `${this.formMessage.error.lettersOnly}`;
    this.invalidEmailMessage = `${this.formMessage.error.email}`;
    this.invalidPhoneMessage = `${this.formMessage.error.phone}`;
    this.lettersOnlyRegex = /^[A-Za-zÀ-ÿ -]*$/;
    this.emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    this.firstError = null;
    this.isFormValid = Array.prototype.filter.call(this.inputElements, (input) => input.classList.contains('.error')).length <= 0;
    this.events();
  }

  events() {
    this.form.addEventListener('submit', (e) => {
      this.isFormValid = true;

      this.inputElements.forEach((input) => {
        this.validate(input);
      });

      if (this.isFormValid) {
        this.form.querySelectorAll('input[type="tel"]').forEach( (input) => {
          input.value = input.intlTelInput.getNumber();
        });
        this.submit.classList.add('pe-n', 'o-05');
      } else {
        e.preventDefault();
        this.firstError && this.firstError.focus();
        this.firstError = null;
      }
    });

    this.inputElements.forEach((input) => {
      if (!(input.classList.contains('preventErrorEventListener'))) {
        input.addEventListener('input', () => {
          !this.isFormValid && this.validate(input);
        });
      }
    });
  }

  validate(element) {
    element.hasAttribute('required') && this.validateRequired(element);

    if (element.value !== '') {
      this.validateLettersOnly(element);
      this.validateEmail(element);
      this.validatePhone(element);
    }
  }

  validateRequired(element) {
    if (element.getAttribute('type') === "checkbox") {
      !element.checked ? this.showError(element, this.requiredMessage) : this.removeError(element);
    } else {
      element.value === '' ? this.showError(element, this.requiredMessage) : this.removeError(element);
    }
  }

  validateEmail(element) {
    if (element.getAttribute('type') === 'email') {
      !element.value.match(this.emailRegex) ? this.showError(element, this.invalidEmailMessage) : this.removeError(element);
    }
  }

  validatePhone(element) {
    if (element.getAttribute('type') === "tel") {
      const isFormatValid = element.intlTelInput.isValidNumber();
      !isFormatValid ? this.showError(element, this.invalidPhoneMessage) : this.removeError(element);
    }
  }

  validateLettersOnly(element) {
    if (element.getAttribute('name') === "firstname" || element.getAttribute('name') === "lastname") {
      !element.value.match(this.lettersOnlyRegex) ? this.showError(element, this.lettersOnlyMessage) : this.removeError(element);
    }
  }

  showError(element, message) {
    element.classList.remove('validate');
    element.classList.add('error');
    element.setAttribute("aria-invalid", "true");

    // Display error message
    let existingError = element.closest('.field').querySelector('.error-message');
    if (existingError !== null) {
      existingError.textContent = message;
    } else {
      let errorElement = document.createElement('span');
      errorElement.textContent = message;
      errorElement.setAttribute('aria-live', 'polite');
      errorElement.classList.add('error-message', 'd-ib', 'c-error', 'fs-xxxxs', 'mt-xxxs');
      element.closest('.field').append(errorElement);
    }

    this.firstError = this.firstError === null ? element : this.firstError;
    this.isFormValid = false;
  }

  removeError(element) {
    element.classList.replace('error', 'validate');
    element.removeAttribute("aria-invalid");

    // Remove error message
    let existingError = element.closest('.field').querySelector('.error-message');
    existingError !== null && existingError.remove();
  }
}
  const forms = document.querySelectorAll('[data-form-validate]');

  forms.forEach((form) => {
    form.validate = new formValidation(form);
  });

